// Context provider for the injected user API client.

import { type ReactNode } from 'react';
import { UsersApiContext } from './UsersApiContext';
import type { UsersApiClient } from './types';

export function UsersApiProvider({
  client,
  children,
}: {
  client: UsersApiClient;
  children: ReactNode;
}) {
  return (
    <UsersApiContext.Provider value={client}>{children}</UsersApiContext.Provider>
  );
}
